import { render, staticRenderFns } from "./SendPointsToGeocoding.vue?vue&type=template&id=4854f748&scoped=true"
import script from "./SendPointsToGeocoding.vue?vue&type=script&lang=js"
export * from "./SendPointsToGeocoding.vue?vue&type=script&lang=js"
import style0 from "./SendPointsToGeocoding.vue?vue&type=style&index=0&id=4854f748&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4854f748",
  null
  
)

export default component.exports